import { render, staticRenderFns } from "./ContactReminders.vue?vue&type=template&id=727261fb"
import script from "./ContactReminders.vue?vue&type=script&lang=js"
export * from "./ContactReminders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports